import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0ca9db81"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/styles/web/contact_home.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/styles/web/home.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/styles/web/main_style.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "@/styles/web/swiper.min.css?vue&type=style&index=3&prod&lang=css&external"
import style4 from "@/styles/web/swiper-bundle.min.css?vue&type=style&index=4&prod&lang=css&external"
import style5 from "./index.vue?vue&type=style&index=5&id=0ca9db81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports